import React from 'react';
import './AboutIcaim27.css';
import Navbar from '../../components/navbar';
import PageHeader from '../../about/PageHeader';
import Footer from '../../components/Footer';

const AboutIcaim27 = () => {
  return (
    <>
      <Navbar />


      <PageHeader
        title="About ICAIM"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "About ICAIM" },
        ]}
      />
      <div className="icaim-simple-container">
        <div className="icaim-simple-content">
          <p className="has-drop-cap">
            This global conference provides a premier platform for industry experts, researchers, and academics to explore the transformative impact of Information Technology and Artificial Intelligence on sustainable practices. The primary focus is on leveraging digital innovations and AI-driven solutions to build a sustainable future in critical sectors like agriculture and healthcare, highlighting the strategic role of digital ecosystems.
          </p>

          <p>
            The event emphasizes the application of advanced technologies—such as data analytics, the Internet of Things (IoT), and automation—to solve modern challenges. Key discussions will revolve around optimizing resources, improving accessibility, and developing intelligent systems that support precision agriculture, smart healthcare delivery, predictive analytics, and technology-enabled decision-making for inclusive growth.
          </p>

          <p>
            By encouraging collaboration across various disciplines and sectors, including academia, industry, and government, the conference strives to generate scalable and responsible AI solutions. The goal is to facilitate knowledge sharing and practical insights that promote sustainable development across interconnected sectors, contributing to a resilient, technology-enabled society for the future.
          </p>
        </div>

      </div>
      <Footer />
    </>

  );

};

export default AboutIcaim27;